module.exports = __webpack_public_path__ + "img/ilustracao-info.e8ec30d4.svg";